module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-4.258 14.27l-4.452 4.542 1.06 6.464c.102.634-.262.902-.816.598L16 22.828l-5.534 3.044c-.554.304-.92.04-.816-.596l1.06-6.464-4.452-4.542c-.446-.456-.302-.9.32-.994l6.142-.934 2.786-5.906c.274-.58.716-.58.99 0l2.784 5.906 6.142.934c.62.094.764.538.32.994z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/star-1.js
// module id = 1431
// module chunks = 14